import { useMutation, useQueryClient } from "react-query";
import { showNotification } from "@mantine/notifications";
import { AxiosError } from "axios";

import { updateBrainstormIdea } from "modules/collaboration/api/brainstorming";

import { UpdateBrainstormIdeaDto } from "modules/collaboration/types/dto";
import { BrainstormIdea } from "modules/collaboration/types/entities";

import { BRAINSTORM_IDEAS_QUERY_KEY } from "../queries/useBrainstormIdeasQuery";
import { BRAINSTORM_IDEAS_STATS_QUERY_KEY } from "../queries/useBrainstormIdeasStatsQuery";
import { SINGLE_BRAINSTORM_IDEA_QUERY_KEY } from "../queries/useSingleBrainstormIdeaQuery";

import { getBrainstormIdeaSynthesisQueryKey } from "../queries/useBrainstormIdeaSynthesisQuery";
import { sendTrackingEvent } from "modules/core/api/tracking";
import { trackingEvents } from "modules/collaboration/config/tracking/events";

export const useUpdateBrainstormIdeaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    BrainstormIdea,
    AxiosError,
    {
      id: string;
      dto: UpdateBrainstormIdeaDto;
    }
  >({
    mutationFn: updateBrainstormIdea,
    onSuccess: ({ id, project_id }) => {
      queryClient.invalidateQueries(BRAINSTORM_IDEAS_QUERY_KEY);
      queryClient.invalidateQueries(BRAINSTORM_IDEAS_STATS_QUERY_KEY);
      queryClient.invalidateQueries(SINGLE_BRAINSTORM_IDEA_QUERY_KEY);
      queryClient.removeQueries(
        getBrainstormIdeaSynthesisQueryKey({
          id,
          project_id
        })
      );

      sendTrackingEvent(trackingEvents.brainstorming_idea.edited_idea);
    },
    onError: () => {
      showNotification({
        message: "Could not update brainstorm idea",
        color: "red"
      });
    }
  });
};
